import React from 'react';
import { Stack } from 'react-bootstrap';
import { Cell, Legend, Pie, PieChart, ResponsiveContainer } from 'recharts';
import { GREEN_YELLOW_RED_COLORS } from './candidate-scoring-util';

const ClientDashboardCandidateDonuts = ({ aggregations }) => {
  return (
    <>
      <Stack
        direction="horizontal"
        className="justify-content-evenly pt-1 d-none d-md-flex candidate-quality-horizontal"
        gap={1}
      >
        <Stack className="align-items-center">
          <Stack direction="horizontal" className="flex-row justify-content-center">
            <div className="pe-2" style={{ height: '6em', width: '6em' }}>
              <ResponsiveContainer height="100%" width="100%">
                <PieChart>
                  <Pie
                    data={[
                      { value: aggregations.highlyRecommend.percent },
                      { value: 100 - aggregations.highlyRecommend.percent },
                    ]}
                    dataKey="value"
                    innerRadius={20}
                    outerRadius={30}
                  >
                    <Cell fill={GREEN_YELLOW_RED_COLORS.highlyRecommend.primary} />
                    <Cell fill={GREEN_YELLOW_RED_COLORS.highlyRecommend.secondary} />
                  </Pie>
                  <Legend content={<div>{aggregations.highlyRecommend.count}</div>} verticalAlign="middle" />
                </PieChart>
              </ResponsiveContainer>
            </div>
            <div className="align-middle">{`${aggregations.highlyRecommend.percent}%`}</div>
          </Stack>
          <div>Highly Recommend</div>
        </Stack>
        <Stack className="align-items-center">
          <Stack direction="horizontal" className="flex-row justify-content-center">
            <div style={{ height: '6em', width: '6em' }}>
              <ResponsiveContainer height="100%" width="100%">
                <PieChart>
                  <Pie
                    data={[{ value: aggregations.recommend.percent }, { value: 100 - aggregations.recommend.percent }]}
                    dataKey="value"
                    innerRadius={20}
                    outerRadius={30}
                  >
                    <Cell fill={GREEN_YELLOW_RED_COLORS.recommend.primary} />
                    <Cell fill={GREEN_YELLOW_RED_COLORS.recommend.secondary} />
                  </Pie>
                  <Legend content={<div>{aggregations.recommend.count}</div>} verticalAlign="middle" />
                </PieChart>
              </ResponsiveContainer>
            </div>
            <div className="align-middle">{`${aggregations.recommend.percent}%`}</div>
          </Stack>
          <div>Recommend</div>
        </Stack>
        <Stack className="align-items-center">
          <Stack direction="horizontal" className="flex-row justify-content-center">
            <div style={{ height: '6em', width: '6em' }}>
              <ResponsiveContainer height="100%" width="100%">
                <PieChart>
                  <Pie
                    data={[
                      { value: aggregations.recommendWithCaution.percent },
                      { value: 100 - aggregations.recommendWithCaution.percent },
                    ]}
                    dataKey="value"
                    innerRadius={20}
                    outerRadius={30}
                  >
                    <Cell fill={GREEN_YELLOW_RED_COLORS.recommendWithCaution.primary} />
                    <Cell fill={GREEN_YELLOW_RED_COLORS.recommendWithCaution.secondary} />
                  </Pie>
                  <Legend content={<div>{aggregations.recommendWithCaution.count}</div>} verticalAlign="middle" />
                </PieChart>
              </ResponsiveContainer>
            </div>
            <div className="align-middle">{`${aggregations.recommendWithCaution.percent}%`}</div>
          </Stack>
          <div>Recommend With</div>
          <div>Caution</div>
        </Stack>
        <Stack className="align-items-center">
          <Stack direction="horizontal" className="flex-row justify-content-center">
            <div style={{ height: '6em', width: '6em' }}>
              <ResponsiveContainer height="100%" width="100%">
                <PieChart>
                  <Pie
                    data={[
                      { value: aggregations.doNotRecommend.percent },
                      { value: 100 - aggregations.doNotRecommend.percent },
                    ]}
                    dataKey="value"
                    innerRadius={20}
                    outerRadius={30}
                  >
                    <Cell fill={GREEN_YELLOW_RED_COLORS.doNotRecommend.primary} />
                    <Cell fill={GREEN_YELLOW_RED_COLORS.doNotRecommend.secondary} />
                  </Pie>
                  <Legend content={<div>{aggregations.doNotRecommend.count}</div>} verticalAlign="middle" />
                </PieChart>
              </ResponsiveContainer>
            </div>
            <div className="align-middle">{`${aggregations.doNotRecommend.percent}%`}</div>
          </Stack>
          <div>Do Not</div>
          <div>Recommend</div>
        </Stack>
      </Stack>
      <Stack direction="vertical" className="justify-content-evenly pt-1 d-md-none" gap={1}>
        <Stack className="align-items-center">
          <Stack direction="horizontal" className="flex-row justify-content-center">
            <div style={{ height: '6em', width: '6em' }}>
              <ResponsiveContainer height="100%" width="100%">
                <PieChart>
                  <Pie
                    data={[
                      { value: aggregations.highlyRecommend.percent },
                      { value: 100 - aggregations.highlyRecommend.percent },
                    ]}
                    dataKey="value"
                    innerRadius={20}
                    outerRadius={30}
                  >
                    <Cell fill={GREEN_YELLOW_RED_COLORS.highlyRecommend.primary} />
                    <Cell fill={GREEN_YELLOW_RED_COLORS.highlyRecommend.secondary} />
                  </Pie>
                  <Legend content={<div>{aggregations.highlyRecommend.count}</div>} verticalAlign="middle" />
                </PieChart>
              </ResponsiveContainer>
            </div>
          </Stack>
          <div className="align-middle" style={{ fontSize: '1.2em' }}>{`${aggregations.highlyRecommend.percent}%`}</div>
          <div>Highly Recommend</div>
        </Stack>
        <Stack className="align-items-center">
          <Stack direction="horizontal" className="flex-row justify-content-center">
            <div style={{ height: '6em', width: '6em' }}>
              <ResponsiveContainer height="100%" width="100%">
                <PieChart>
                  <Pie
                    data={[{ value: aggregations.recommend.percent }, { value: 100 - aggregations.recommend.percent }]}
                    dataKey="value"
                    innerRadius={20}
                    outerRadius={30}
                  >
                    <Cell fill={GREEN_YELLOW_RED_COLORS.recommend.primary} />
                    <Cell fill={GREEN_YELLOW_RED_COLORS.recommend.secondary} />
                  </Pie>
                  <Legend content={<div>{aggregations.recommend.count}</div>} verticalAlign="middle" />
                </PieChart>
              </ResponsiveContainer>
            </div>
          </Stack>
          <div className="align-middle" style={{ fontSize: '1.2em' }}>{`${aggregations.recommend.percent}%`}</div>
          <div>Recommend</div>
        </Stack>
        <Stack className="align-items-center">
          <Stack direction="horizontal" className="flex-row justify-content-center">
            <div style={{ height: '6em', width: '6em' }}>
              <ResponsiveContainer height="100%" width="100%">
                <PieChart>
                  <Pie
                    data={[
                      { value: aggregations.recommendWithCaution.percent },
                      { value: 100 - aggregations.recommendWithCaution.percent },
                    ]}
                    dataKey="value"
                    innerRadius={20}
                    outerRadius={30}
                  >
                    <Cell fill={GREEN_YELLOW_RED_COLORS.recommendWithCaution.primary} />
                    <Cell fill={GREEN_YELLOW_RED_COLORS.recommendWithCaution.secondary} />
                  </Pie>
                  <Legend content={<div>{aggregations.recommendWithCaution.count}</div>} verticalAlign="middle" />
                </PieChart>
              </ResponsiveContainer>
            </div>
          </Stack>
          <div
            className="align-middle"
            style={{ fontSize: '1.2em' }}
          >{`${aggregations.recommendWithCaution.percent}%`}</div>
          <div>Recommend With</div>
          <div>Caution</div>
        </Stack>
        <Stack className="align-items-center">
          <Stack direction="horizontal" className="flex-row justify-content-center">
            <div style={{ height: '6em', width: '6em' }}>
              <ResponsiveContainer height="100%" width="100%">
                <PieChart>
                  <Pie
                    data={[
                      { value: aggregations.doNotRecommend.percent },
                      { value: 100 - aggregations.doNotRecommend.percent },
                    ]}
                    dataKey="value"
                    innerRadius={20}
                    outerRadius={30}
                  >
                    <Cell fill={GREEN_YELLOW_RED_COLORS.doNotRecommend.primary} />
                    <Cell fill={GREEN_YELLOW_RED_COLORS.doNotRecommend.secondary} />
                  </Pie>
                  <Legend content={<div>{aggregations.doNotRecommend.count}</div>} verticalAlign="middle" />
                </PieChart>
              </ResponsiveContainer>
            </div>
          </Stack>
          <div className="align-middle" style={{ fontSize: '1.2em' }}>{`${aggregations.doNotRecommend.percent}%`}</div>
          <div>Do Not</div>
          <div>Recommend</div>
        </Stack>
      </Stack>
    </>
  );
};

export default ClientDashboardCandidateDonuts;
